import { io } from 'socket.io-client';

let socket;

const noopSocket = {
    on: () => {},
    off: () => {},
    emit: () => {},
    connect: () => {},
    disconnect: () => {},
};

export const getSocket = () => {
    const socketUrl = process.env.REACT_APP_SOCKET_URL;
    
    // If no socket URL is provided or disabled, return safe no-op object (prevents 404 polling loop)
    if (!socketUrl || socketUrl.trim() === '' || socketUrl === 'undefined') {
        return noopSocket;
    }

    if (!socket) {
        socket = io(socketUrl, {
            transports: ['websocket', 'polling'],
            autoConnect: true,
            reconnectionAttempts: 2,
            timeout: 5000,
        });
    }
    return socket;
};
